"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = require("react");
var _OrderSummarySelectionComponent = _interopRequireDefault(require("./OrderSummarySelectionComponent"));
var _storeProvider = require("./../util/storeProvider");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
class OrderSummaryComponent extends _react.PureComponent {
  render() {
    const {
      selections,
      totalPrice,
      commonContent: content
    } = this.props;
    const {
      store
    } = this.context;
    if (selections.length === 0) {
      return null;
    }
    return /*#__PURE__*/React.createElement(_react.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-xs-12"
    }, /*#__PURE__*/React.createElement("h4", {
      className: "text-black"
    }, content.orderSummary))), /*#__PURE__*/React.createElement("ul", {
      id: "orderSummaryList",
      className: "list-unstyled"
    }, selections.map((group, i) => /*#__PURE__*/React.createElement(_OrderSummarySelectionComponent.default, _extends({
      key: `${i}SummaryCartItem`
    }, group)))), /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-xs-5"
    }, /*#__PURE__*/React.createElement("p", {
      className: "bold total-text"
    }, content.total)), /*#__PURE__*/React.createElement("div", {
      className: "col-xs-7 text-right"
    }, /*#__PURE__*/React.createElement("p", {
      id: "totalPrice",
      className: "bold total-price"
    }, store.formatMicrounits(totalPrice)))), (content.legalTaxText || content.legalTermLengthText) && /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "card-disclaimer text-center mb-1 hidden-lg-down"
    }, /*#__PURE__*/React.createElement("p", null, content.legalTaxText, /*#__PURE__*/React.createElement("br", null), content.legalTermLengthText))));
  }
}
OrderSummaryComponent.propTypes = {
  selections: _propTypes.default.arrayOf(_propTypes.default.object),
  totalPrice: _propTypes.default.number,
  commonContent: _propTypes.default.shape({
    legalTaxText: _propTypes.default.string,
    legalTermLengthText: _propTypes.default.string,
    orderSummary: _propTypes.default.string,
    total: _propTypes.default.string
  })
};
var _default = exports.default = (0, _storeProvider.provideContext)(OrderSummaryComponent);